module.exports = __webpack_public_path__ + "static/img/NR.8c7bcea7.svg";